(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('loew-cart-code')) {
    class LoewCartCode extends HTMLElement {
      async connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.events = new AbortController();
        this.form = this.querySelector('form');
        this.input = this.querySelector('input');
        this.status = this.querySelector('[role="status"]');
        this.list = this.querySelector('.loew-cart-code__list');
        this.form.addEventListener('submit', event => {
          event.preventDefault();
          const code = this.input.value.trim();
          if (!code) { this.message('Bitte gib einen Rabattcode ein.', true); this.input.focus(); return; }
          this.change(code, false);
        }, { signal: this.events.signal });
        this.list.addEventListener('click', event => {
          const button = event.target.closest('button[data-code]');
          if (button) this.change(button.dataset.code, true);
        }, { signal: this.events.signal });
        try {
          this.cartStore = (await import('cart-store')).default;
          if (!this.isConnected) return;
          this.unsubscribe = this.cartStore.subscribe(state => this.render(state.cart));
          this.render(this.cartStore.getState().cart);
          const response = await fetch(this.root + 'cart.js', { headers: { Accept:'application/json' } });
          if (response.ok && this.isConnected) {
            let cart = await response.json();
            const discounts = [...(cart.cart_level_discount_applications || []), ...(cart.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(value => value.discount_application))];
            if (discounts.some(value => value?.title === '5 % Loew Vorteil')) {
              const recalculated = await fetch(this.root + 'cart/update.js', { method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({updates:{}}) });
              if (recalculated.ok) { cart = await recalculated.json(); await this.cartStore.refresh(); }
            }
            this.render(cart);
          }
        } catch (error) {
          this.message('Du kannst den Code hier anwenden oder an der Kasse eingeben.');
        }
      }
      disconnectedCallback() { this.unsubscribe?.(); this.events?.abort(); this.initialized = false; }
      get root() { return window.Shopify?.routes?.root || '/'; }
      message(text, error = false) { this.status.textContent = text; this.status.dataset.error = String(error); }
      render(cart) {
        this.codes = Array.isArray(cart?.discount_codes) ? cart.discount_codes : [];
        this.list.replaceChildren();
        for (const item of this.codes) {
          const row = document.createElement('div'); row.className = 'loew-cart-code__tag';
          const label = document.createElement('span'); label.textContent = item.code + (item.applicable ? ' · angewendet' : ' · aktuell nicht anwendbar');
          const remove = document.createElement('button'); remove.type = 'button'; remove.dataset.code = item.code; remove.textContent = 'Entfernen'; remove.setAttribute('aria-label', item.code + ' entfernen');
          row.append(label, remove); this.list.append(row);
        }
      }
      async change(code, remove) {
        if (LoewCartCode.busy) return;
        LoewCartCode.busy = true;
        document.querySelectorAll('loew-cart-code input, loew-cart-code button').forEach(el => el.disabled = true);
        this.message('Rabattcode wird geprüft …');
        try {
          const snapshot = await fetch(this.root + 'cart.js', { headers: { Accept:'application/json' } });
          if (!snapshot.ok) throw new Error('cart');
          const cart = await snapshot.json();
          let codes = (cart.discount_codes || []).map(item => item.code).filter(value => value.toLowerCase() !== code.toLowerCase());
          if (!remove) codes.push(code);
          const response = await fetch(this.root + 'cart/update.js', { method:'POST', headers: { 'Content-Type':'application/json', Accept:'application/json' }, body:JSON.stringify({ discount:codes.join(',') }) });
          if (!response.ok) throw new Error('discount');
          const updated = await response.json();
          this.render(updated);
          if (this.cartStore) {
            await this.cartStore.refresh();
          } else {
            window.location.assign(this.root + 'cart'); return;
          }
          const applied = updated.discount_codes?.find(item => item.code.toLowerCase() === code.toLowerCase() && item.applicable);
          if (remove) this.message('Rabattcode entfernt. Deine Preise wurden aktualisiert.');
          else if (applied) { this.message('Rabattcode angewendet. Deine Preise wurden aktualisiert.'); this.input.value = ''; }
          else this.message('Dieser Code ist aktuell nicht anwendbar. Prüfe die Aktionsbedingungen und melde dich bei einem Kontorabatt in deinem aktivierten Kundenkonto an.', true);
        } catch (error) {
          this.message('Der Code konnte gerade nicht geprüft werden. Bitte versuche es erneut oder gib ihn an der Kasse ein.', true);
        } finally {
          LoewCartCode.busy = false;
          document.querySelectorAll('loew-cart-code input, loew-cart-code button').forEach(el => el.disabled = false);
        }
      }
    }
    customElements.define('loew-cart-code', LoewCartCode);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["loew-stock-status"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('loew-combined-stock')) {
    customElements.define('loew-combined-stock', class extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('quick-shop, product-single') || this.parentElement;
        this.onQuantity = (event) => {
          if (event.target.closest('variant-selects, variant-radios, variant-mixed-inputs')) {
            this.paused = true;
            clearTimeout(this.debounce);
            this.controller?.abort();
            this.controller = null;
            this.paint({status: 'checking', text: this.dataset.loadingLabel, delivery: ''});
          } else if (event.target.matches('input[name="quantity"]')) this.refresh(true);
        };
        this.scope.addEventListener('change', this.onQuantity);
        this.scope.addEventListener('input', this.onQuantity);
        this.refresh();
        this.timer = setInterval(() => {
          if (document.visibilityState === 'visible') this.refresh();
        }, 30000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        clearTimeout(this.debounce);
        this.controller?.abort();
        this.scope?.removeEventListener('change', this.onQuantity);
        this.scope?.removeEventListener('input', this.onQuantity);
      }
      paint(data) {
        const classes = {available: 'stock-note--in-stock', low: 'stock-note--in-stock stock-note--low', sold: 'stock-note--sold', checking: 'stock-note--low'};
        if (!classes[data.status] || typeof data.text !== 'string' || typeof data.delivery !== 'string') throw new Error('Invalid availability');
        this.querySelector('.loew-stock').className = 'stock-note loew-stock ' + classes[data.status];
        this.querySelector('.stock-note__text').textContent = data.status === 'available' ? this.dataset.availableLabel : data.status === 'checking' ? this.dataset.loadingLabel : data.text;
      }
      refresh(quantityChanged = false) {
        if (this.paused) return;
        clearTimeout(this.debounce);
        this.controller?.abort();
        if (quantityChanged) this.paint({status: 'checking', text: this.dataset.loadingLabel, delivery: ''});
        this.debounce = setTimeout(() => this.load(), quantityChanged ? 180 : 0);
      }
      async load() {
        const controller = new AbortController();
        this.controller = controller;
        const timeout = setTimeout(() => controller.abort(), 8000);
        try {
          const quantity = this.scope.querySelector('input[name="quantity"]')?.value || '1';
          const url = new URL('https://www.elan-ai.de/api/besorger/availability');
          url.search = new URLSearchParams({product: this.dataset.product, variant: this.dataset.variant, quantity}).toString();
          const response = await fetch(url, {signal: controller.signal, credentials: 'omit', cache: 'no-store'});
          if (!response.ok) throw new Error('Availability unavailable');
          const data = await response.json();
          if (this.isConnected && this.controller === controller && !controller.signal.aborted) this.paint(data);
        } catch {
          if (this.isConnected && this.controller === controller) this.paint({status: 'checking', text: this.dataset.loadingLabel, delivery: ''});
        } finally {
          clearTimeout(timeout);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
